<template>
  <div class="courseList">
    <div
      :class="['courseItem', { cur: curId == item.id }]"
      v-for="(item, index) in leftTree"
      :key="index"
      :title="item.courseName || item.name"
      @click="treeClick(item.id)"
    >
      {{ item.courseName || item.name }}
    </div>
  </div>
</template>

<script>
import * as api from "@/api/sourceApi";
export default {
  name: "LeftTree",
  components: {},
  props: {
    treeHeight: {
      // 表格高度
      type: [String],
      default: "100%",
    },
  },
  data() {
    return {
      //左侧目录树
      leftTree: [],
      curId: "",
    };
  },

  created() {},
  mounted() {},

  methods: {
    //左侧目录
    treeList(id) {
      this.leftTree = [];
      api.getCourseList({ courseId: this.$route.query.id }).then((res) => {
        if (res.code == "0") {
          this.leftTree = res.data;
          if (res.data.length) {
            this.treeClick(res.data[0]["id"]);
          }
        }
      });
    },
    treeClick(id) {
      this.curId = id;
      this.$emit("showListStandard", id);
    },
  },
};
</script>

<style scoped lang="scss">
.courseList {
  box-sizing: border-box;
  border-right: 1px solid #ccc;
  padding: 8px;
  height: 360px;
  overflow: auto;
  .courseItem {
    height: 23px;
    line-height: 23px;
    padding: 2px;
    font-size: 12px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      background: #f6f8fb;
    }
    &.cur {
      background-color: rgba(83, 151, 247, 0.8);
      border-radius: 4px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/components/standardProduct.vue